class WorknestTokenError extends Error {
  constructor(message) {
    super(message);
    this.name = "WorknestTokenError";
  }
}

export default WorknestTokenError;
